__turbopack_context__.v({
  "container": "nAyq6G_container",
  "footer": "nAyq6G_footer",
});
